module.exports = __webpack_public_path__ + "static/media/email.41590716.svg";